<template>
  <v-menu
    ref="menu"
    v-model="menu"
    transition="scale-transition"
    :close-on-content-click="false"
    offset-y
    min-width="0"
  >
    <template v-slot:activator="{ on }">
      <text-input
        :value="dateText"
        v-bind="$attrs"
        class="date-input"
        :label="label"
        hide-details
        readonly
        v-on="on"
        @click:clear="onClear"
      />
    </template>
    <v-date-picker
      ref="picker"
      v-bind="$props"
      :value="datePickerValue"
      type="month"
      :max="max"
      @change="onChange"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import TextInput from '@/components/forms/text-input'

import { months } from '@/utils/date'

export default {
  name: 'DateRangePicker',
  components: {
    TextInput,
  },
  props: {
    label: {
      type: String,
      default: 'Date Period',
    },
    value: {
      type: String,
      default: undefined,
    },
    max: {
      type: String,
      default: undefined,
    },
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    dateText() {
      if (!this.value) return
      const [year, month] = this.value.split('-')
      const monthFormatted = months[Number(month) - 1]
      return `${monthFormatted} ${year}`
    },
    datePickerValue() {
      return this.value && this.value.substring(0, 7)
    },
  },
  methods: {
    onChange(value) {
      this.$emit('input', value)
      this.menu = false
    },
    onClear() {
      this.$emit('input', undefined)
    },
  },
}
</script>

<style lang="scss" scoped>
.date-input {
  min-width: 200px;
}
</style>
